import { create } from 'zustand';
import { persist } from 'zustand/middleware';

const secureStorage = {
  setItem(key, value) {
    localStorage.setItem(key, value);
  },
  getItem(key) {
    return localStorage.getItem(key);
  },
  removeItem(key) {
    localStorage.removeItem(key);
  }
};

const useGlobale = create(
  persist(
    (set) => ({
      authenticated: false,
      user: null,

      updateUserInfo: (updatedUserData) => {
        set(state => ({
          ...state,
          user: {
            ...state.user,
            ...updatedUserData
          }
        }));
      },

      login: async (credentials, user) => {
        try {
          const authData = {
            access: credentials.access,
            refresh: credentials.refresh
          };

          secureStorage.setItem('auth_tokens', JSON.stringify(authData));
          secureStorage.setItem('credentials', JSON.stringify(credentials));

          set({
            authenticated: true,
            user: user,
          });
        } catch (error) {
          console.error('Error during login:', error);
        }
      },

      logout: async () => {
        try {
          secureStorage.removeItem('auth_tokens');
          secureStorage.removeItem('credentials');
          set({
            authenticated: false,
            user: null,
          });
        } catch (error) {
          console.error('Error during logout:', error);
        }
      },

      checkAuth: async () => {
        try {
          const tokensString = secureStorage.getItem('auth_tokens');
          if (tokensString) {
            const tokens = JSON.parse(tokensString);
            // Vérifier que les tokens existent et ne sont pas vides
            if (tokens.access && tokens.refresh) {
              set({ authenticated: !!tokens.access });
            } else {
              // Tokens invalides, nettoyer
              secureStorage.removeItem('auth_tokens');
              secureStorage.removeItem('credentials');
              set({ authenticated: false, user: null });
            }
          } else {
            set({ authenticated: false, user: null });
          }
        } catch (error) {
          console.error('Error checking auth:', error);
          // En cas d'erreur, nettoyer tout
          secureStorage.removeItem('auth_tokens');
          secureStorage.removeItem('credentials');
          set({ authenticated: false, user: null });
        }
      },
    }),
    {
      name: 'auth-storage',
    }
  )
);

export default useGlobale;